import React from 'react';
import { AlertCircle, RefreshCw, ArrowLeft } from 'lucide-react';
import { Button } from './ui';
import { captureError } from '../lib/sentry';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });

    // Capture error with Sentry
    captureError(error, {
      extra: { errorInfo }
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
          <div className="max-w-md w-full text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900">
              <AlertCircle className="h-8 w-8 text-red-600 dark:text-red-400" />
            </div>
            <h1 className="text-2xl font-bold mb-2">
              რაღაც შეცდომა მოხდა
            </h1>
            <p className="text-muted-foreground mb-4">
              {this.state.error?.message || 'ჩვენ ვმუშაობთ პრობლემის მოგვარებაზე'}
            </p>
            <div className="flex gap-2 justify-center">
              <Button onClick={this.handleReload}>
                <RefreshCw className="h-4 w-4 mr-2" />
                განახლება
              </Button>
              <Button variant="outline" onClick={this.handleGoBack}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                უკან
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
